import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Form } from "react-bootstrap";
import VehicleInfoViewModel from "viewModels/common/vehicleInfoViewModel";
import AsyncSelect from "../../../controls/asyncSelect";
import countryFilter from "@edaz/utils/countryFilter";

const CountryIdWithConfirmation: FunctionComponent<{
  vm: VehicleInfoViewModel;
  disabled?: boolean;
  context?: "new" | "old";
  isConfirmation?: boolean;
  errorMessage?: string;
}> = observer(({ vm, disabled, isConfirmation, errorMessage, context }) => {
  const ta = (code: string) => vm.localizationService.translateAttribute("orderItem", code);
  const countries = vm.loadCountries;

  return (
    <>
      <div className="col-sm-6 form-group">
        <Form.Label>{ta(context ? `${context}.countryId` : "countryId")}</Form.Label>
        <AsyncSelect
          target={vm.item}
          property="countryId"
          loadOptions={countries}
          defaultOptions={vm.defaultCountries}
          placeholder={vm.localizationService.translateGeneral("common.selectCountry")}
          errorMessage={errorMessage}
          mode="key"
          filterOption={countryFilter}
        />
      </div>
      <div className="col-sm-6 form-group">
        <Form.Label>{ta(context ? `${context}.again.countryId` : "again.countryId")}</Form.Label>
        <AsyncSelect
          target={vm.item}
          property="_countryIdConfirmation"
          loadOptions={countries}
          defaultOptions={vm.defaultCountries}
          placeholder={vm.localizationService.translateGeneral("common.selectCountry")}
          mode="key"
          filterOption={countryFilter}
        />
      </div>
    </>
  );
});

export default CountryIdWithConfirmation;
